import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import './index.css';
import App from './App';
import { ErrorBoundary } from 'components/error-boundry';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';

Sentry.init({
  dsn: 'https://89a79e0c6c8f40d3b874d407219a42d7@o464187.ingest.sentry.io/4504810752311296',
  integrations: [new BrowserTracing()],
  tracesSampleRate: 1.0,
  environment: import.meta.env.VITE_ENVIRONMENT,
  release: import.meta.env.VITE_COMMIT_HASH,
  ignoreErrors: [
    // Network errors
    /A network error occurred/i,
    /network error (Error)/i,
    /timeout of 0ms exceeded/i,
    /Request limit expired/i,
    /Network Error/i,
    /Network request failed/i,

    // 4xx errors
    /Request failed with status code [4][0-9][0-9]/i,
  ],
  denyUrls: [
    // Browser extensions
    /^chrome:\/\//i,
    /^chrome-extension:\/\//i,
    /safari-(web-)?extension:/i,
  ],
});

ReactDOM.render(
  <React.StrictMode>
    <ErrorBoundary>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
    </ErrorBoundary>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
